import { ChartRiskLevel } from './ChartRiskLevel';
import { ChartAssetRisk } from './ChartAssetsRisk';
import { ChartAssetsOverview } from './ChartAssetsOverview';

import { DynaVault } from '../../../api/DynaVaultsAPI';
import { TokenTableRow } from 'structure/capital-manager/types';

interface ChartsSectionProps {
  vaultList: DynaVault[];
  tokens: TokenTableRow[];
}

export const ChartsSection = (props: ChartsSectionProps) => {
  const { tokens } = props;

  return (
    <div className='flex flex-row flex-wrap justify-around gap-8'>
      <div className='w-[200px] xl:w-[250px]'>
        <ChartRiskLevel tokens={tokens} />
      </div>
      <div className='w-[200px] xl:w-[250px]'>
        <ChartAssetRisk tokens={tokens} />
      </div>
      <div className='w-[200px] xl:w-[250px]'>
        <ChartAssetsOverview tokens={tokens} />
      </div>
    </div>
  );
};
